var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditsPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 66,
    viewBox: "0 0 62 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_b_142_2128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4667 1.77202C28.5095 -0.562113 33.4905 -0.562113 37.5333 1.77202L54.7776 11.728C58.8204 14.0621 61.3109 18.3758 61.3109 23.044V42.956C61.3109 47.6242 58.8204 51.9379 54.7776 54.272L37.5333 64.228C33.4905 66.5621 28.5095 66.5621 24.4667 64.228L7.22244 54.272C3.1796 51.9379 0.689112 47.6242 0.689112 42.956V23.044C0.689112 18.3758 3.1796 14.0621 7.22245 11.728L24.4667 1.77202Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9528 2.61399C28.6948 0.453526 33.3052 0.453527 37.0472 2.61399L54.2914 12.5699C58.0335 14.7304 60.3387 18.7231 60.3387 23.044V42.956C60.3387 47.2769 58.0335 51.2696 54.2914 53.4301L37.0472 63.386C33.3052 65.5465 28.6948 65.5465 24.9528 63.386L7.70856 53.4301C3.96652 51.2696 1.66133 47.2769 1.66133 42.956V23.044C1.66133 18.7231 3.96652 14.7304 7.70856 12.5699L24.9528 2.61399Z",
    stroke: "url(#paint0_linear_142_2128)",
    strokeOpacity: 0.4,
    strokeWidth: 1.94444
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_142_2128",
    x: -9.79793,
    y: -10.4654,
    width: 81.5959,
    height: 86.9308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.24345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_142_2128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_142_2128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_2128",
    x1: 8.63889,
    y1: -5.40278,
    x2: 55.7917,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsPolygon);
export default __webpack_public_path__ + "static/media/credits-polygon.7d162dc21ca4e2e626a75ed9fc092ae7.svg";
export { ForwardRef as ReactComponent };